import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#with-borders" }),
  /*#__PURE__*/_createTextVNode(" With borders ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Option A")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Option B")
const _hoisted_6 = { style: {"margin-top":"20px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Option A")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Option B")
const _hoisted_9 = { style: {"margin-top":"20px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Option A")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Option B")
const _hoisted_12 = { style: {"margin-top":"20px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Option A")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Option B")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode(_component_el_radio, {
          modelValue: _ctx.radio1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radio1 = $event)),
          label: "1",
          border: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: _ctx.radio1,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radio1 = $event)),
          label: "2",
          border: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_radio, {
          modelValue: _ctx.radio2,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radio2 = $event)),
          label: "1",
          border: "",
          size: "medium"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: _ctx.radio2,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.radio2 = $event)),
          label: "2",
          border: "",
          size: "medium"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio3,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.radio3 = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: "1",
              border: ""
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: "2",
              border: "",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio4,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.radio4 = $event)),
          size: "mini",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: "1",
              border: ""
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: "2",
              border: ""
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}